@if (points > 0) {
<div class="_pointsBanner flex flex-middle">
    <i class="m-r-2 inline-flex _pointsIcon"
       [ngClass]="status.busy ? 'icon-loading' : 'icon-coins'"></i>
    <span class="p2 flex-grow center">
        {{'You will earn' | translate}}
        <span class="s2">{{'% coins and rosettes' | translate : points}}</span>
        {{'for this purchase' | translate}}
    </span>
    <i class="m-l-2 inline-flex _pointsIcon"
       [ngClass]="status.busy ? 'icon-loading' : 'icon-rosette'"></i>
</div>
} @else if (signInBanner) {
<div class="_signInBanner bg-col-51 p-a box-shadow-1">
    <p>{{'Sign in to win points in every purchase!' | translate}}</p>
    <button class="button-inline block m-t-2"
            [routerLink]="['/login']">{{'Sign In or Create an Account' | translate}}</button>
</div>
}
